module.exports = __webpack_public_path__ + "img/delivery.a8fec9b2.svg";